import styled from "@emotion/styled";
import {Link} from "react-router-dom";

const success = "#5cb85c";
const warning = "#f0ad4e";
const dangerRed = "#ff5f5f";
const neutral = "#003b00";

const color = props => {
  if (props.danger) {
    return dangerRed;
  } else if (props.success) {
    return success;
  } else if (props.warning) {
    return warning;
  }
  return neutral;
};

const Button = styled.button`
  display: flex;
  gap: 5px;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: ${props => (props.large ? "1.1rem" : "0.875rem")};
  border: 1.5px solid ${props => color(props)};
  font-weight: 600;
  background-color: ${props => (props.primary ? props.theme.newGreen : "transparent")};
  color: ${props => color(props)};
  border-radius: 8px;
  cursor: pointer;
  text-decoration: none;
  padding: 0.5em 1em;
  transition: all 0.15s ease;
  letter-spacing: -0.01em;

  &:hover {
    background-color: ${props => props.theme.newGreen};
    color: ${props => (props.type === "danger" ? "white" : "initial")};
  }

  &:disabled {
    cursor: not-allowed !important;
    pointer-events: none;
    background-color: #f3f4f6;
    opacity: 0.5;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 44px;
    height: 24px;
  }
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #d1d5db;
    -webkit-transition: 0.2s;
    transition: 0.2s;
  }
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    -webkit-transition: 0.2s;
    transition: 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  input:checked + .slider {
    background-color: #059669;
  }
  input:focus + .slider {
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.15);
  }
  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
  }
  .slider.round {
    border-radius: 34px;
  }
  .slider.round:before {
    border-radius: 50%;
  }
`;

const AnchorButton = Button.withComponent("a");
const LinkButton = Button.withComponent(Link);

const TransparentButton = styled(Button)`
  border-color: transparent;
  background-color: transparent;

  &:hover {
    border-color: ${({theme}) => theme.almostBlack};
  }
`;

export {AnchorButton, LinkButton, TransparentButton};
export default Button;
